import React, {Component} from 'react';

class PagingBtn extends Component {
    constructor(props){
        super(props);
        
        this.pageList = [];
        this.state = ({
            currentPage: props.currentPage,
            totalPages: props.totalPages,
            onUpdatePage: props.onUpdatePage, 
            
        });
        
        this.setPageList(props.currentPage, props.totalPages);
    }

    componentWillReceiveProps = (nextProps) => {
    	this.setPageListAndUpdateState(nextProps.currentPage, nextProps.totalPages);
    }
    
    setPageList = (currentPage, totalPages) => {
    	this.pageList = [];
        const setIndex = Math.ceil((currentPage + 1) / 10) - 1;

        for (var i = 1 + setIndex * 10; i <= Math.min((setIndex + 1) * 10, totalPages); i++) {
            this.pageList.push(i);
        }
    }
    
    setPageListAndUpdateState = (currentPage, totalPages) => {
        this.setPageList(currentPage, totalPages);

        this.setState({
            currentPage: currentPage,
            totalPages: totalPages
        });
    }
    
    onPrevPage = () => {
    	const curPage = Math.max(0, this.state.currentPage - 10);
    	this.setState({
            currentPage: curPage
        });

    	this.props.onUpdatePage(curPage);
    }

    onNextPage = () => {
    	const curPage = Math.min(this.state.totalPages - 1, this.state.currentPage + 10);
    	this.setState({
            currentPage: curPage
        });
    	
        this.props.onUpdatePage(curPage);
    }
    
    saveCurPageAndRequestVocabList = (page) => {
    	const curPage = page - 1;
    	this.setState({
            currentPage: curPage
        });

    	this.props.onUpdatePage(curPage);
    }

    render() {
        return (
            <div className="wrap-paging">
            	{(this.state.currentPage > 0 && this.state.totalPages > 10) && 
            		<a className="directionBtn prev small blue" onClick={this.onPrevPage} />}
	                {
	                		this.pageList.map((page, i) =>
	                			<a key={i} className={(page == this.state.currentPage + 1) ? " active" : ""}
	                				onClick={() => this.saveCurPageAndRequestVocabList(page)}>{page}</a>)
	                }
            	{(this.state.currentPage < this.state.totalPages -1  && this.state.totalPages > 10) &&
            		<a className="directionBtn next small blue" onClick={this.onNextPage} />}
            </div>
        );
    }
}

PagingBtn.defaultProps = {
    currentPage: 0,
    totalPages: 0,
    onUpdatePage: (id) => {}
}

export default PagingBtn;


// WEBPACK FOOTER //
// ./src/components/Buttons/PagingBtn/index.js